/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { withStyles, useMediaQuery } from '@material-ui/core';
import { object } from 'prop-types';

const styles = ({
    container: {
        // removing margin above product details
        marginTop: '-5px',
    },
    image: {
        width: '100%',
    },
});

const PassportBundleBanner = ({ classes, bundleDetails }) => {
    const isDesktop = useMediaQuery('(min-width: 601px)');

    let image = '';
    let title = '';
    if (isDesktop) {
        image = bundleDetails.desktopImage?.url;
        title = bundleDetails.desktopImage?.title;
    } else {
        image = bundleDetails.mobileImage?.url;
        title = bundleDetails.mobileImage?.title;
    }
    return (
        <div className={classes.container}>
            <img className={classes.image} alt={title} src={image} />
        </div>
    );
};

PassportBundleBanner.propTypes = {
    classes: object,
    bundleDetails: object,
};

PassportBundleBanner.defaultProps = {
    classes: {},
    bundleDetails: {
        desktopImage: '',
        mobileImage: '',
    },
};

export default withStyles(styles)(PassportBundleBanner);
